import * as React from 'react';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@/components/atoms/select';
import {generateQtys} from '@/components/helpers/configuratorHelpers.ts';
import {randomString} from '@/components/helpers';

export type QtySelectorProps = {
  qty?: number
  maxQty?: number
  setQty: (qty: number) => void
}

export function QtySelector(props: QtySelectorProps) {
  const qty = props.qty || 1; // Default to 1 if no qty provided

  const setQty = (value: string) => {
    props.setQty(parseInt(value));
  }
  if(props.maxQty) {
    const qtys = generateQtys(props.maxQty);
    return(<div>
      <Select onValueChange={setQty}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder={qty} />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            <SelectLabel >Qty</SelectLabel>
            {
              qtys.map(q => (<SelectItem key={`__qty__${randomString}__${q}`} value={q}>{q}</SelectItem>))
            }
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>)
  }
  return null;
}
